import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=df0c289e&scoped=true&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"
import style0 from "./retail.vue?vue&type=style&index=0&id=df0c289e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c289e",
  null
  
)

export default component.exports